import { BaseService } from "./common/base";
import type { DispatchOrganization } from "../../../../api/src/dispatch-organization/entities/dispatch-organization.entity";
import type { CreateDispatchOrganizationDto } from "../../../../api/src/dispatch-organization/dto/create-dispatch-organization.dto";
import type { UpdateDispatchOrganizationDto } from "../../../../api/src/dispatch-organization/dto/update-dispatch-organization.dto";

export class DispatchOrganizationService extends BaseService<
  DispatchOrganization,
  any,
  CreateDispatchOrganizationDto,
  UpdateDispatchOrganizationDto
> {
  constructor() {
    super("dispatch-organization");
  }

  addUser(
    id: string,
    payload: { userId: string; userType: string; profileId: string }
  ) {
    return this._post(`${id}/team/add-user`, payload);
  }

  getTeam(id: string) {
    return this._get(`${id}/team`);
  }

  getInventory(id: string) {
    return this._get(`${id}/inventory`);
  }

  findSupplyRequests(id: string) {
    return this._get(`${id}/inventory/supply-request`);
  }

  createSupplyRequest(
    id: string,
    payload: {
      status: string;
      items: { item: { id: string }; quantity: number }[];
    }
  ) {
    return this._post(`${id}/inventory/supply-request`, payload);
  }
}
